import { TReduxActions } from '../../types/redux';
import { EBannersActionTypes } from '../../actions/banners';
import { IBannerData } from '../../../typings/api';

export function bannersReducer(state: IBannerData[] = [], action: TReduxActions) {
  if (action.type === EBannersActionTypes.SetBanners) {
    return [...action.payload];
  }

  return state;
}
